/* eslint-disable react/require-default-props */
import { InputHTMLAttributes, ReactElement, useEffect, useRef } from 'react';

import { useField } from '@unform/core';
import { FiSearch } from 'react-icons/fi';

import Button from '../Button';

import * as S from './styles';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  name: string;
  hideBtn?: boolean;
  onSearch: (query: string) => void;
}

function InputAdmin({
  name,
  hideBtn,
  onSearch,
  ...rest
}: InputProps): ReactElement {
  const inputRef = useRef<HTMLInputElement>(null);

  const { fieldName, defaultValue, registerField } = useField(name);

  useEffect(() => {
    registerField<string>({
      name: fieldName,
      ref: inputRef.current,
      path: 'value',
    });
  }, [fieldName, registerField]);

  return (
    <S.Container>
      <FiSearch size={22} style={{ marginInline: '1rem' }} />
      <S.Input
        type="text"
        name={name}
        ref={inputRef}
        defaultValue={defaultValue}
        {...rest}
        onKeyUp={(event) => {
          if (event.key === 'Enter') {
            onSearch(inputRef.current?.value ?? '');
          }
        }}
      />

      {!hideBtn && (
        <Button
          textContent="Buscar"
          variant="black"
          size="small"
          onClick={() => onSearch(inputRef.current?.value ?? '')}
          style={{ height: 32, width: 150 }}
        />
      )}
    </S.Container>
  );
}

export default InputAdmin;
